<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;"' class="border-bottom my-3 pb-3 " >
                <template #default>محصولات   </template>
                </m-h5><m-a v-bind='{...{"href":"{\"name\":\"CreateStoreProduct\",\"params\":{}}","target":"_self"},...{}}' :style='"font-size: 13px;"' class="btn btn-sm btn-primary" >
                <template #default>ساخت محصول   </template>
                </m-a><m-dashboard-products-300 v-bind='{...{},...{}}' :style='""' class="dashboard-products-300 py-4" ></m-dashboard-products-300></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mDashboardProducts300 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Dashboard/DashboardProducts300/DashboardProducts300';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mA,mDashboardProducts300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
